export const createSlug = (str: string): string => {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // strip non-alphanumeric (except space/dash)
    .replace(/\s+/g, '-') // spaces → dashes
    .replace(/-+/g, '-'); // collapse multiple dashes
};

// Remove leading/trailing slashes then replace remaining internal slashes with single hyphen
export const normalizeSlug = (slug: string): string => {
  return slug
    .replace(/^\/+/, '')
    .replace(/\/+$/, '')
    .replace(/\/+/, '-') // collapse first slash group
    .replace(/\//g, '-') // replace any remaining single slashes
    .replace(/-+/g, '-'); // collapse multiple hyphens
};
